import { storeInformationQueries } from "$/hooks/use-store-information"
import { requireNonFreeTier } from "$/lib/require-non-free-tier"
import { requireOwner } from "$/lib/require-owner"
import { STORE_TYPE } from "@repo/common"
import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/(app)/_auth/check-in")({
  loader: async ({ context: { queryClient } }) => {
    await requireNonFreeTier(queryClient)
    await requireOwner(queryClient)

    // Mobile stores have no fixed check-in location for customers to scan
    // a QR code at, so the sidebar hides this for them too.
    const storeInfo = await queryClient.ensureQueryData(
      storeInformationQueries.detail(queryClient),
    )
    const currentStore = storeInfo.stores.find(
      (store) => store.id === storeInfo.storeId,
    )
    if (currentStore?.type === STORE_TYPE.MOBILE) {
      throw redirect({ to: "/", replace: true })
    }

    return {
      crumbs: "alfred.pages.checkIn.crumbs.checkIn",
    }
  },
})
